import { motion } from "framer-motion";
import SectionLabel from "./SectionLabel";
import HoverVideo from "./HoverVideo";

// Curated short form clips. Swap sources as new clips are uploaded.
const projects = [
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/ntuopwaq_g3veft4e_videoplayback%20%284%29.mp4",
    poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/0y2ao02w_yyxr4b4p_video-capture-t0001.99seg-239.png",
  },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/5ews6wpt_94i44oj0_videoplayback%20%286%29.mp4", poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/obv7uf59_wey8f6z7_video-capture-t0001.54seg-7567.png" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/781c0ion_vstfta42_videoplayback%20%282%29.mp4", poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/e5xbgyha_k8vf6eim_video-capture-t0002.32seg-993.png" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/xxkdlodf_qr2hq2zn_videoplayback%20%283%29.mp4", poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/rk4upc22_f0m0dij7_video-capture-t0003.47seg-9900.png" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/1roe5w9c_5qr3p5f8_videoplayback.mp4", poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/qil5dyw2_lnjnub46_video-capture-t0002.52seg-3719.png" },
  {
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/vjyfqxtx_n357k48v_videoplayback%20%285%29.mp4",
    poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/he4jhc2q_8q6j62xw_video-capture-t0000.84seg-2122.png",
  },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/uudvim0t_imbnmsgb_vidssave.com%20You%20Don%E2%80%99t%20Need%2030%20Funds%20-%205-6%20funds%20should%20be%20enough%20720P.mp4", poster: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/3tfh71ph_hju31l4l_video-capture-t0018.35seg-5690.png" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_edit-showcase-270/artifacts/erbl3r35_i1non41y_36%20Soft%20Small%20Apartment%20Decor%20-%20Pin-879820477213442488.mp4" },
];

export default function ShortFormClips() {
  return (
    <section
      id="short-form"
      data-testid="short-form-clips-section"
      className="relative px-6 md:px-16 lg:px-32 py-24 md:py-32 bg-[#070707] border-y border-[#1a1a1a]"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
        <div>
          <SectionLabel number="02" label="Short Form Clips" testId="short-form-label" />
          <h2 className="font-display font-bold uppercase text-2xl md:text-4xl tracking-tighter leading-[0.95] [word-spacing:0.18em] max-w-3xl">
            Clips that <span className="text-[#F4C75E]">don't get skipped.</span>
          </h2>
        </div>
        <p className="text-sm md:text-base text-[#A3A3A3] max-w-sm">
          Every episode turned into vertical, retention first cuts, ready for
          YouTube Shorts, Reels and TikTok.
        </p>
      </div>

      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-7">
        {projects.map((p, i) => {
          const isNinth = i === 8;
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`short-form-item-${i}`}
              className={`relative ${isNinth ? "lg:col-start-2" : ""}`}
            >
              <HoverVideo src={p.src} poster={p.poster} className="aspect-[9/16] w-full" />
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
